import { useQuery } from '@tanstack/react-query';

import { dataTrendApi } from '../api';
import { CalendarDataDailyTrendWithData } from '@demind-inc/core';

interface UseCalendarDailyTrendParams {
  userId: string;
  date: string;
  dataTrendId: string;
  enabled?: boolean;
}

interface UseCalendarDailyTrendQueryParams {
  queryKey: ['lifestack.trend.calendar.daily', UseCalendarDailyTrendParams];
}

export const useFetchCalendarDailyTrend = ({
  userId,
  date,
  dataTrendId,
  enabled = true,
}: UseCalendarDailyTrendParams) => {
  const calendarDailyTrendQuery = useQuery({
    queryKey: ['lifestack.trend.calendar.daily', { userId, date, dataTrendId }],
    queryFn: ({ queryKey }: UseCalendarDailyTrendQueryParams) => {
      const [, { userId, date, dataTrendId }] = queryKey;
      return dataTrendApi
        .getCalendarDailyTrend(userId, date, dataTrendId)
        .then(({ data }) => data as CalendarDataDailyTrendWithData);
    },
    refetchOnWindowFocus: false,
    staleTime: 15000, // 15s
    enabled: !!userId && !!dataTrendId && enabled,
  });

  return {
    calendarDailyTrend: calendarDailyTrendQuery.data,
    ...calendarDailyTrendQuery,
  };
}; 